import Header from "./components/Header";
import Hero from "./components/Hero";
import LianSection from "./components/LianSection";
import ChuanSection from "./components/ChuanSection";
import KuaSection from "./components/KuaSection";
import QuanSection from "./components/QuanSection";
import GuideSection from "./components/GuideSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";

const FAQ_STRUCTURED = [
  {
    q: "71吃瓜主要整理哪些内容？",
    a: "我们聚焦娱乐圈里的跨圈联动、跨界合作与串门互动，把相关爆料、路透与后续进展收在一条时间线上，方便你看清来龙去脉。",
  },
  {
    q: "“联动瓜”和“串门瓜”有什么区别？",
    a: "联动通常指多个圈子、作品或团队之间正式的合作互动；串门更像一位熟面孔在别的节目或舞台上的短暂客串亮相。我们都会单独归类并配上进度更新。",
  },
  {
    q: "吃瓜时如何避免被带节奏？",
    a: "先看信息来源是否可追溯（官微、片方、正规媒体），再看多方说法是否一致。本站每则爆料都会标注来源口径，把实锤、路透与猜测分开呈现。",
  },
  {
    q: "我发现了新的联动或串门线索，如何提供给71吃瓜？",
    a: "欢迎通过页面底部的订阅与联系表单告诉我们。投稿请尽量附上可核实的时间、平台与原始出处。",
  },
];

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "71吃瓜",
      url: "https://dtnqq.cn/",
      description:
        "71吃瓜专注追踪娱乐圈跨圈联动、明星串门、圈外爆料与吃瓜后续更新，把联动瓜与跨界小料收在一条线。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "FAQPage",
      mainEntity: FAQ_STRUCTURED.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Header />
      <main>
        <Hero />
        <LianSection />
        <ChuanSection />
        <KuaSection />
        <QuanSection />
        <GuideSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}